<template>
	<transition name="preloader">
		<div class="preloader">
			<div>
				<div class="one"></div>
				<div class="two"></div>
				<div class="three"></div>
				<div class="four"></div>
			</div>
		</div>
	</transition>
</template>
<script>
export default {
	name: "Preloader"
};
</script>
<style scoped lang="scss">
.preloader {
	height: 100vh;
	width: 100vw;
	position: fixed;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1000;
	text-align: center;
	display: flex;
	justify-content: space-around;
	align-items: center;
	background-color: rgba(204, 204, 204, 0.46);

	div {
		display: flex;
		justify-content: space-around;
		height: 2rem;
		width: 15rem;

		div {
			width: 2rem;
			height: 2rem;
			background-color: rgba(255, 0, 0, 0.68);
			border-radius: 50%;
			box-shadow: 0 0 100px #000000;
			opacity: 0;
		}
	}

	.one {
		animation: preloader 1s ease 0.2s infinite;
	}

	.two {
		animation: preloader 1s ease 0.4s infinite;
	}

	.three {
		animation: preloader 1s ease 0.6s infinite;
	}

	.four {
		animation: preloader 1s ease 0.8s infinite;
	}

	@keyframes preloader {
		0% {
			opacity: 0;
		}

		50% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}
}

.preloader-enter-active {
	transition: all 1s ease;
}

.preloader-leave-active {
	transition: all 1s ease;
}

.preloader-enter, .preloader-leave-to {
	opacity: 0;
}

.preloader-move {
	transition: all 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue